import S from './styles';
import React from "react"
import youtubeIcon from '../../resources/youtube.svg';
import { GA_ACTION, GAClickEvent } from "../../utils/ga"

const googleFormLink = 'https://youtube.com/playlist?list=PLfx4MMAj7YbFUnrH7M4Fc8IMAkP5NusNi';

export const FloatingButton = () => (
  <S.Button
    href={googleFormLink}
    target='_blank'
    onClick={ GAClickEvent('플로팅_버튼', GA_ACTION.CLICK, '유튜브') }
  >
    <S.Icon src={youtubeIcon} />
    <span>영상보기</span>
  </S.Button>
)
